var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78003 21L21.53 3",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.05C9.97098 19.3531 10.9828 19.5049 12 19.5C16.1 19.57 20.26 16.69 22.82 13.86C23.0962 13.5563 23.2492 13.1605 23.2492 12.75C23.2492 12.3395 23.0962 11.9437 22.82 11.64C21.8943 10.6169 20.8655 9.69198 19.75 8.88",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0899 7.27006C15.5162 6.45364 13.7727 6.01861 11.9999 6.00006C7.99991 5.93006 3.79991 8.75006 1.17991 11.6401C0.903754 11.9438 0.750732 12.3395 0.750732 12.7501C0.750732 13.1606 0.903754 13.5563 1.17991 13.8601C2.59979 15.4474 4.26409 16.7977 6.10991 17.8601",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.07C8.45752 14.3174 8.20504 13.3943 8.289 12.4703C8.37295 11.5464 8.7877 10.6839 9.45695 10.0414C10.1262 9.39893 11.0049 9.01972 11.9315 8.97353C12.8581 8.92734 13.7702 9.21727 14.5 9.79001",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.75C15.75 13.2425 15.653 13.7301 15.4645 14.1851C15.2761 14.64 14.9999 15.0534 14.6517 15.4017C14.3034 15.7499 13.89 16.0261 13.4351 16.2145C12.9801 16.403 12.4925 16.5 12 16.5",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOff);
export default __webpack_public_path__ + "static/media/ViewOff.73ed4e9ca0c211e1b64694d0111d2138.svg";
export { ForwardRef as ReactComponent };